export default __webpack_public_path__ + "img/diversity.4545c4a7.svg";